
import Vue, { PropType } from 'vue'
import RLoader from '@/components/forms/RLoader.vue'

type RButtonType = 'primary' | 'secondary' | 'link' | 'info' | 'close'
type ButtonType = 'button' | 'submit'
type ButtonSize = 'sm' | 'md' | 'lg'

export default Vue.extend({
  name: 'RButton',
  props: {
    type: {
      type: String as PropType<RButtonType>,
      default: 'primary',
    },
    spinning: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    submit: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String as PropType<ButtonSize>,
      default: 'md',
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
    },
  },
  components: {
    RLoader,
  },
  mounted() {
    if (!this.disabled) {
      this.autofocus && this.focus()
    }
  },
  computed: {
    buttonType(): ButtonType {
      return this.submit === true ? 'submit' : 'button'
    },
    isDisabled(): boolean {
      return this.spinning || this.disabled
    },
    label(): string | null {
      return this.type === 'close' ? 'close' : null
    },
    classes(): string[] {
      return [
        this.type,
        this.size,
        this.isDisabled ? 'disabled' : '',
        this.fullWidth ? 'full-width' : '',
      ]
    },
    optionallyInvisibleSlot(): string[] {
      const optionallyVisible = this.spinning ? 'invisible' : ''
      return ['slot', 'flex-center', optionallyVisible]
    },
  },
  methods: {
    focus(): void {
      ;(this.$refs.button as HTMLButtonElement).focus()
    },
  },
})
